import React, { useEffect, useRef } from "react";
import { AlertTriangle } from "lucide-react";

export function DuplicateWarning({ matches, onCreateAnyway, onCancel }) {
  const ref = useRef(null);
  useEffect(() => { ref.current?.scrollIntoView({ behavior: "smooth", block: "center" }); }, []);
  return (
    <div ref={ref} className="card-flat p-4 mb-4 border-[var(--warn)] bg-[var(--gold-soft)]" data-testid="dup-warning">
      <div className="flex items-center gap-2 font-medium text-sm mb-2"><AlertTriangle size={14} /> This client may already exist</div>
      <ul className="text-xs space-y-1 mb-3">
        {matches.map((m) => (
          <li key={m.id} data-testid={`dup-warning-${m.id}`}>
            <b>{m.client_name}</b>{m.client_uid ? ` (${m.client_uid})` : ""}{m.registered_no ? ` · ${m.registered_no}` : ""} — {m.reasons.join(", ")}
          </li>
        ))}
      </ul>
      <div className="flex gap-2">
        <button type="button" data-testid="dup-create-anyway" onClick={onCreateAnyway} className="btn-primary text-xs !py-1">Create anyway</button>
        <button type="button" data-testid="dup-cancel" onClick={onCancel} className="btn-ghost text-xs !py-1">Go back and check</button>
      </div>
    </div>
  );
}
